module.exports = __webpack_public_path__ + "static/media/4.f98b5970.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/slides/Designbase/assets/4.jpg
// module id = 64
// module chunks = 0